import { onSystemModeChange } from './applyTheme'

/**
 * Applies the saved theme before the app mounts, and keeps 'system' mode in
 * step with the OS afterwards. Called once from main.js.
 */
export function initTheme(store) {
  store.commit('appConfig/APPLY_THEME')
  onSystemModeChange(() => {
    if (store.state.appConfig.layout.theme.mode === 'system') store.commit('appConfig/APPLY_THEME')
  })
}
